import "@arco-design/web-react/es/InputNumber/style";
import _InputNumber from "@arco-design/web-react/es/InputNumber";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Grid/style";
import _Grid from "@arco-design/web-react/es/Grid";
import React, { useCallback, useContext, useEffect, useMemo } from 'react';
import dayjs from 'dayjs';
const {
  Row,
  Col
} = _Grid;
const FormItem = _Form.Item;
const TextArea = _Input.TextArea;
import { FlowFormContext } from '../FlowFormContext';
import PersonSelector from '@/components/PersonSelector';
import { RangePicker } from '@/components/DatePicker';
import { useSelector } from 'react-redux';
import { flowExcelStore, useApproveUsers, useFilterApproveUsers } from '@/store/flowExcelStore';
function LeaveForm() {
  const {
    setSubmitHandler,
    type,
    data
  } = useContext(FlowFormContext);
  const userInfo = useSelector(state => state.userInfo);
  const {
    form,
    approveForm
  } = flowExcelStore;
  const [users] = useApproveUsers();
  const leaveDate = _Form.useWatch('leaveDate', form);
  const [startDate, endDate] = leaveDate || [];
  const leaveDays = useMemo(() => {
    if (!startDate || !endDate) return 0;
    const start = dayjs(startDate);
    const end = dayjs(endDate);
    return end.diff(start, 'day') + 1;
  }, [startDate, endDate]);
  useEffect(() => {
    if (data?.id && form) {
      form.setFieldsValue({
        ...data,
        leaveDate: [data.startDate, data.endDate]
      });
      approveForm?.setFieldsValue({
        ...data
      });
    }
  }, [data, form, approveForm]);
  useEffect(() => {
    if (type === 'add' && approveForm) {
      approveForm.setFieldsValue({
        groupLeader: '19911335-b756-4250-b786-1d75704f0e87,10f82154-c20c-4440-b8fd-c6a701f53246',
        groupLeaderName: '李中坤,李伟',
        deptApprove: '19911335-b756-4250-b786-1d75704f0e87',
        deptApproveName: '李中坤'
      });
    }
  }, [type, approveForm]);
  useEffect(() => {
    if (type === 'add' && form) {
      form.setFieldsValue({
        name: '请假申请',
        userId: userInfo?.userId || '',
        userName: userInfo?.name || userInfo?.userName || '',
        positionName: '前端开发',
        leaveDate: ['2026-08-06', '2026-08-08'],
        reason: '请假原因',
        workReceiver: '19911335-b756-4250-b786-1d75704f0e87',
        workReceiverName: '李中坤'
      });
    }
  }, [type, form, userInfo?.userId, userInfo?.name, userInfo?.userName]);
  useEffect(() => {
    if (leaveDays !== undefined && leaveDays !== null) {
      form.setFieldValue('totalDays', leaveDays);
    }
  }, [leaveDays, form]);

  // 注册提交处理：表单值交出去之前，LeaveForm 做最后加工
  useEffect(() => {
    setSubmitHandler(({
      ...values
    }) => {
      delete values.leaveDate;
      return {
        ...values,
        totalDays: leaveDays,
        startDate,
        endDate,
        title: `${values.userName}${startDate}至${endDate}为期${leaveDays}天${values.name}`
      };
    });
  }, [setSubmitHandler, leaveDays, startDate, endDate]);

  // leaveDays <= 3 时移除 value === 'gmApprove' 的节点，> 3 时按原始快照恢复。
  // leaveDays < 10 时移除 value === 'chairman' 的节点，> 10 时按原始快照恢复。
  const filterGmApprove = useCallback(() => leaveDays >= 0 && leaveDays <= 3, [leaveDays]);
  const restoreGmApprove = useCallback(() => leaveDays > 3, [leaveDays]);
  useFilterApproveUsers(filterGmApprove, restoreGmApprove, 'gmApprove', false);
  const filterChairman = useCallback(() => leaveDays >= 0 && leaveDays < 10, [leaveDays]);
  const restoreChairman = useCallback(() => leaveDays > 10, [leaveDays]);
  useFilterApproveUsers(filterChairman, restoreChairman, 'chairman', false);
  console.log('users', users.map(u => ({
    value: u.value,
    text: u.text,
    uid: u.uid
  })));
  return /*#__PURE__*/React.createElement(Row, {
    gutter: 20
  }, /*#__PURE__*/React.createElement(Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(FormItem, {
    field: "name",
    label: "\u540D\u79F0",
    rules: [{
      required: true,
      message: '请输入名称'
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: "\u8BF7\u8F93\u5165\u540D\u79F0"
  }))), /*#__PURE__*/React.createElement(Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(FormItem, {
    field: "userId",
    label: "\u8BF7\u5047\u4EBA",
    hidden: true,
    rules: [{
      required: true,
      message: '请输入请假人ID'
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: "\u8BF7\u8F93\u5165\u8BF7\u5047\u4EBAID"
  })), /*#__PURE__*/React.createElement(FormItem, {
    field: "userName",
    label: "\u8BF7\u5047\u4EBA",
    rules: [{
      required: true,
      message: '请输入请假人'
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: "\u8BF7\u8F93\u5165\u8BF7\u5047\u4EBA"
  }))), /*#__PURE__*/React.createElement(Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(FormItem, {
    field: "leaveDate",
    label: "\u8BF7\u5047\u65E5\u671F",
    rules: [{
      required: true,
      message: '请选择请假日期'
    }]
  }, /*#__PURE__*/React.createElement(RangePicker, {
    style: {
      width: '100%'
    }
  }))), /*#__PURE__*/React.createElement(Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(FormItem, {
    field: "totalDays",
    label: "\u7D2F\u8BA1\u8BF7\u5047\u5929\u6570",
    rules: [{
      required: true,
      message: '请选择请假日期'
    }]
  }, /*#__PURE__*/React.createElement(_InputNumber, {
    placeholder: "\u8BF7\u9009\u62E9\u8BF7\u5047\u65E5\u671F"
  }))), /*#__PURE__*/React.createElement(Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(FormItem, {
    field: "positionName",
    label: "\u5C97\u4F4D\u540D\u79F0",
    rules: [{
      required: true,
      message: '请选择岗位名称'
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: "\u8BF7\u8F93\u5165\u5C97\u4F4D\u540D\u79F0"
  }))), /*#__PURE__*/React.createElement(Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(FormItem, {
    field: "workReceiver",
    label: "\u5DE5\u4F5C\u63A5\u6536\u4EBA",
    rules: [{
      required: true,
      message: '请选择工作接收人'
    }]
  }, /*#__PURE__*/React.createElement(PersonSelector, {
    form: form,
    labelKey: "workReceiverName"
  }))), /*#__PURE__*/React.createElement(Col, {
    span: 24
  }, /*#__PURE__*/React.createElement(FormItem, {
    field: "reason",
    label: "\u8BF7\u5047\u4E8B\u7531",
    rules: [{
      required: true,
      message: '请输入请假事由'
    }]
  }, /*#__PURE__*/React.createElement(TextArea, {
    placeholder: "\u8BF7\u8F93\u5165\u8BF7\u5047\u4E8B\u7531",
    autoSize: {
      minRows: 4
    }
  }))));
}
export { LeaveForm };